import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { API_URL } from '../../../../../services/config';
import { TransportManagementProfileModel } from '../models';
import { TransportManagementProfileEndpoint } from '../constants/transport-management-profile-endpoint';

@Injectable({
  providedIn: 'root',
})
export class TransportManagementDefaultProfileService {
  constructor(private http: WrapperHttpService) {}

  setTransportManagementProfileItemDefaultProfileToggle({
    profileId,
    isDefault,
  }: {
    profileId: number;
    isDefault: boolean;
  }): Observable<boolean> {
    const url = `${API_URL}${TransportManagementProfileEndpoint.Base}${TransportManagementProfileEndpoint.Profiles}${TransportManagementProfileEndpoint.Default}`;

    return this.http.withLoading().put<boolean>(url, { profileId, isDefault });
  }

  getTransportManagementDefaultProfile(): Observable<TransportManagementProfileModel> {
    const url = `${API_URL}${TransportManagementProfileEndpoint.Base}${TransportManagementProfileEndpoint.Profiles}${TransportManagementProfileEndpoint.Default}`;
    return this.http.withLoading().get<TransportManagementProfileModel>(url);
  }

  getTransportManagementDefaultProfileAffectedUsers(profileId: number): Observable<number> {
    const url = `${API_URL}${TransportManagementProfileEndpoint.Base}${TransportManagementProfileEndpoint.Profiles}${TransportManagementProfileEndpoint.Default}${TransportManagementProfileEndpoint.Usage}/${profileId}`;
    return this.http.withLoading().get<number>(url);
  }
}
